/* eslint-disable no-new */

import { Controller } from '@hotwired/stimulus';
import loadJs from 'src/lib/load_js';

export default class extends Controller {
  static targets = ['map'];

  static values = {
    apiKey: String,
    mapId: String,
    lat: Number,
    lng: Number,
    zoom: Number,
    markerUrl: String,
  };

  connect() {
    if (typeof window.google === 'undefined') {
      loadJs(
        `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}`,
        () => this.initializeMap(),
      );
    } else {
      this.initializeMap();
    }
  }

  initializeMap() {
    if (!this.map) {
      this.map = new window.google.maps.Map(this.mapTarget, {
        center: { lat: this.latValue, lng: this.lngValue },
        streetViewControl: false,
        mapTypeControl: false,
        zoom: this.zoomValue,
        mapId: this.mapIdValue,
      });

      const icon = {
        url: this.markerUrlValue,
        scaledSize: new window.google.maps.Size(50, 50),
      };

      this.marker = new window.google.maps.Marker({
        position: { lat: 36.555302, lng: -121.923736 },
        icon,
        map: this.map,
        draggable: false,
        zIndex: -20,
      });
    }
  }
}
